import { Grid, Card, CardContent, Typography, Button, Box } from "@mui/material";

function Plans({
    plan,
    setPlan,
    productList,
    selectedProduct,
    setSelectedProduct,
    goToCheckout,
}) {
  
  return (
    <Grid container spacing={4} justifyContent="center">
      {productList.map((product) => {
        // const interval = product.default_price?.recurring?.interval;
        // const price = (product.default_price?.unit_amount / 100).toFixed(2);
        const interval = product.interval;
        const price = (product.unit_amount / 100).toFixed(2);

        return (
          <Grid 
            item 
            xs={12} sm={6} md={4} lg={3} 
            key={product.id} 
            sx={{ display: "flex" }}
          >
            <Card
              sx={{
                minHeight: {lg: 350, md: 350, sm: 'auto'},
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                borderRadius: 4,
                boxShadow: 4,
                p: 1,
                transition: "0.3s",
                border:
                  selectedProduct?.id === product.id
                    ? "2px solid #1976d2"
                    : "1px solid #e0e0e0",
                background:
                  selectedProduct?.id === product.id
                    ? "linear-gradient(135deg,#e3f2fd,#fff)"
                    : "#fff",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: 6,
                },
                cursor: "pointer",
              }}
              onClick={() => {
                setSelectedProduct(product);
                goToCheckout();
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  {product.name}
                </Typography>
                <Typography variant="h3" sx={{ fontWeight: "bold", my: 2 }}>
                  ${price}
                  <Typography
                    component="span"
                    variant="subtitle1"
                    sx={{ color: "text.secondary" }}
                  >
                    /{interval}
                  </Typography>
                </Typography>
                <Typography variant="body2">
                  {product.description || "Cancel anytime."}
                </Typography>
              </CardContent>

              <Box sx={{ p: 2, pt: 0 }}>
                <Button
                  variant={selectedProduct?.id === product.id ? "contained" : "outlined"}
                  size="large"
                  fullWidth
                  sx={{ borderRadius: "30px", fontWeight: 600 }}
                >
                  {selectedProduct?.id === product.id ? "Selected" : "Choose Plan"}
                </Button>
              </Box>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
}

export default Plans;
